import { Button, Col, Container, Row } from 'react-bootstrap';

import PropTypes from 'prop-types';
import footerShape from '../assets/svg/footer-shape.svg';
import styled from 'styled-components';
import { white } from '../theme/colors';

const StyledContainer = styled(Container)`
  background: url(${footerShape}) no-repeat top center/cover;
  position: absolute;
  z-index: 1000;
`;

const StyledButton = styled(Button)`
  border-color: ${white};
  padding: 15px 50px;
  font-size: 22px;
  border-radius: 38px;

  @media screen and (max-width: 520px) {
    font-size: 18px;
    padding: 10px 15px;
    border-radius: 26px;
  }
`;

const GetStartedCTA = ({ navigate }) => (
  <StyledContainer fluid className="app-cta-space">
    <Row>
      <Col className="text-center p-5 p-sm-3 p-md-3">
        <Container fluid="xl">
          <Row className="p-xl-3 p-lg-3 p-md-2 p-sm-1 mb-3 mt-md-4 mt-lg-4 mt-sm-4 mt-xs-3">
            <Col>Register your smart meter now</Col>
          </Row>
          <Row
            className={
              'p-xl-3 p-lg-3 p-md-2 p-sm-1 mb-3 text-center ' +
              'd-flex align-items-center justify-content-center'
            }>
            <StyledButton
              variant="secondary"
              onClick={() => navigate('/signup')}>
              Get started
            </StyledButton>
          </Row>
        </Container>
      </Col>
    </Row>
  </StyledContainer>
);

GetStartedCTA.propTypes = {
  navigate: PropTypes.func,
};

export default GetStartedCTA;
